// extracted by mini-css-extract-plugin
module.exports = {"OverlayBox":"custom_OverlayBox__3O6I_"};